import React from "react";

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from "@mui/material";
import { Archive, Remove } from "@mui/icons-material";
import Service from "../../util/Service";

export default function ProjetoRemoverArquivar(props) {
    const { projeto, action } = props;
    const [tipo, setTipo] = React.useState('');

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (tp) => {
        setTipo(tp);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleExec = () => {
        console.log(projeto);
        if( tipo === 'remover'){
            Service.POST('/api/security/projeto/removeLst', [projeto.id] ).then(r => {
                if(action)action(r);
            });
        }else{
            alert('Ainda não implementado!')
        }
    }
    const montaDescricao = () => {
        if (tipo === 'remover') {
            return (
                <Stack spacing={1}>
                    <Alert severity="error">Remoção do Projeto</Alert>
                    <Typography>Essa ação removerá todas as atividades e os kanban vinculados a esse projeto.</Typography>
                    <Typography variant="body1">
                        Para uma ação segura recomenda arquivar, dessa forma pode restaurar o projeto futuramente.
                    </Typography>
                </Stack>
            )
        }
        return (
            <Stack spacing={1}>
                <Alert severity="info">Arquivar Projeto</Alert>
                <Typography>Todas as tarefas e kanban do projeto serão arquivados.</Typography>
            </Stack>
        )
    }
    return (
        <React.Fragment>
            <Stack>
                <Button startIcon={<Remove />} size='small'
                    onClick={() => handleClickOpen('remover')}
                >
                    Remover
                </Button>
                <Button startIcon={<Archive />} size='small'
                    onClick={() => handleClickOpen('arquivar')}
                >
                    Arquivar
                </Button>
            </Stack>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {tipo === 'remover' ? "Remover projeto" : 'Arquivar projeto'}
                </DialogTitle>
                <DialogContent>
                    {montaDescricao()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button onClick={handleExec} autoFocus>
                        Executar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}